import { FILTER_I18N_KEYS } from '../../../../../features/home/components/constants/i18n/Filteri18nConstants';

export const FILTER_I18N_EN =  {
  [FILTER_I18N_KEYS.all_sources_label]:       "All Sources",
  [FILTER_I18N_KEYS.facebook_category_label]: "Facebook",
  [FILTER_I18N_KEYS.forums_category_label]:   "Forums"
}


// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/filter.i18n.en.js